/* loaded by smart-asset */
export default require("./exclamation-circle-solid~mCULbqrD.svg")